var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudRight = function SvgCloudRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 56,
    fill: "none",
    viewBox: "0 0 206 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF2FF",
    d: "M124.64 46.134c0-.701-.58-1.27-1.297-1.27h-18.239c-.671-10.994-10.002-19.71-21.407-19.71-8.508 0-15.855 4.841-19.325 11.866a14.53 14.53 0 0 0-10.998-4.988c-1.614 0-3.16.273-4.616.753C44.209 25.708 36.168 21 26.988 21 13.23 21 1.999 31.575 1.329 44.865h-.03C.58 44.865 0 45.433 0 46.134c0 .7.58 1.27 1.297 1.27h122.046c.717 0 1.297-.57 1.297-1.27M117.565 56h24.138c.716 0 1.297-.568 1.297-1.27 0-.7-.581-1.268-1.297-1.268h-24.138c-.717 0-1.297.568-1.297 1.269 0 .7.58 1.269 1.297 1.269"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M206 29.774c-10.952-13.415-22.59-6.705-22.59-6.705s-.492-7.425-7.796-11.673c-14.045-8.171-23.693 3.624-23.693 3.624C147.823 3.616 138.886-.46 131.165.04c-20.607 1.327-25.022 15.176-25.796 23.5L79 30h51.316l.032-.22H206z"
  })));
};
export default SvgCloudRight;